import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import caseShadow from '../../assets/images/banners/shadow_case.png';
import { banners } from './CasePromotionBanner.model';

const StyledContainer = styled.div<{ $caseNumber: number }>`
	position: relative;
	width: 100%;
	height: 838px;
	border-radius: 5px;
	background-color: #17312f;
	background-image: url(${(props) => banners[props.$caseNumber].dec}),
		url(${(props) => banners[props.$caseNumber].background});
	background-size: contain, cover;
	background-position: center, center;
	background-repeat: no-repeat, no-repeat;
`;

const StyledCaseShadow = styled.div`
	position: absolute;
	top: 486px;
	left: 50%;
	transform: translateX(-50%);
	width: 600px;
	height: 180px;
	background-image: url(${caseShadow});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledTitle = styled(Text)`
	position: absolute;
	top: 38px;
	left: 50%;
	transform: translateX(-50%);
	color: #ffffff;
	text-align: center;
	white-space: nowrap;
`;

const StyledCount = styled(Text)`
	position: absolute;
	top: 127px;
	left: 50%;
	transform: translateX(-50%);
	font-weight: 500;
	font-size: 16px;
	color: #ffffff;
`;

const StyledProgressWrapper = styled.div`
	position: absolute;
	top: 160px;
	left: 50%;
	transform: translateX(-50%);
	width: 180px;
	height: 20px;
	background-color: #000000;
	border-radius: 5px;
	padding: 2px;
`;

const StyledProgress = styled.div`
	height: 16px;
	background-color: #fabe2c;
	border-radius: 3px;
`;

const StyledDescContainer = styled.div`
	position: absolute;
	bottom: 40px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: 520px;
	height: 100px;
	padding: 20px;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 5px;

	${Text} {
		font-size: 16px;
		text-align: center;
		color: rgba(255, 255, 255, 0.5);
	}
`;

const StyledCaseImageContainer = styled.div`
	position: absolute;
	top: 160px;
	left: 50%;
	transform: translateX(-50%);
	width: 512px;
	height: 512px;
	user-select: none;
	pointer-events: none;
`;

const StyledTimerContainer = styled.div`
	position: absolute;
	top: -20px;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0 12px;
	height: 40px;
	background-color: #ffffff;
	border-radius: 5px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #000000;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
	}
`;

export {
	StyledCaseImageContainer,
	StyledCaseShadow,
	StyledContainer,
	StyledCount,
	StyledDescContainer,
	StyledProgress,
	StyledProgressWrapper,
	StyledTimerContainer,
	StyledTitle,
};
